import api from '../../api/api_resource'
import axios from 'axios';
import LaravelRouter from "../../thirdparty/Ziggy/route";

const state = {
    ids: [],
    all: [],
    total: null,
};

// getters
const getters = {
    all: (state, getters, rootState) => {
        return state.all;
    },
    ids: (state, getters, rootState) => {
        return state.ids;
    },
    getTags: (state, getters, rootState) => {
        return state.all;
    }
};

let getTagsPromise;

// actions
const actions = {
    maybeGetTags({ dispatch }, params){
        const {
            fresh = false,
            args = {}
        } = params
        if (!getTagsPromise || fresh) {
            getTagsPromise = dispatch('getTags', args);
        }
        return getTagsPromise;
    },
    getTags({ commit, state }, args) {
        return new Promise((success, error) => {
            api.index('favourite-tags', args).then(tags => {
                commit('setFavouriteTags', tags.tags);
                success(tags);
            }).catch(error);
        });
    },
    storeFavoriteTag({ commit, state }, args) {
        return new Promise((success, error) => {
            const search_args =  args;
            api.store('favourite-tags', search_args).then(tag => {
                success(tag);
            }).catch(error);
        });
    },
    storeFavoriteTagMapping({ commit, state }, args) {
        return new Promise((success, error) => {
            const search_args =  args;
            api.store('favourite-tag-mapping', search_args).then(result => {
                commit('updateFavouriteTag', result);
                success(result);
            }).catch(error);
        });
    },
    deleteTagMapping({ commit, state }, {tag_id, vehicle_id}) {
        return new Promise((success, error) => {
            let route = LaravelRouter(`favourite-tag-mapping.destroy`, tag_id, true); //
            axios.delete(route, {data: {tag_id, vehicle_id}}).then(response => {
                if (response && response.data && response.data) {
                    commit('removeTagMapping', {tag_id, vehicle_id})
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
    storeManyFavouriteTagMapping({ commit, state }, args) {
        return new Promise((success, error) => {
            let route = LaravelRouter('favourite-tag-mapping.store-many');
            axios.post(route, args).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
};

// mutations
const mutations = {
    setFavouriteTags (state, result) {
        state.all = result;
    },
    updateFavouriteTag(state, result) {
        state.all.forEach((fav, index) => {
            if (result.tag.id === fav.id) {
                result.tag.vehicles = state.all[index].vehicles
                let found = false
                result.tag.vehicles.forEach((vehicleElement, vehicleIndex) => {
                    if (vehicleElement.id === result.vehicle.id) {
                        this._vm.$set(result.tag.vehicles, vehicleIndex, result.vehicle)
                        found = true
                    }
                })
                if (!found) {
                    result.tag.vehicles.push(result.vehicle)
                }
                this._vm.$set(state.all, index, result.tag);
            }
        });
    },
    removeTagMapping(state, tagMapping) {
        state.all.forEach((fav, index) => {
            if (tagMapping.tag_id === fav.id) {
                state.all[index].vehicles.forEach((vehicleElement, vehicleIndex) => {
                    if (vehicleElement.api_id === tagMapping.vehicle_id) {
                        this._vm.$delete(state.all[index].vehicles, vehicleIndex)
                    }
                })
            }
        })
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/favouriteTags.js